var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('accordion',{ref:"accordion",attrs:{"title":_vm.title,"group":_vm.group,"icon-color":_vm.iconColor},on:{"toggle":_vm.onAccordionToggle}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }